import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { FREE_PLAN_LIMIT } from '../../lib/mockPlan';

/**
 * PlanBanner — orange info strip on the Recruiter Dashboard surfacing the
 * mock Free-plan quota state. Dismissable per-session (not persisted) since
 * the user explicitly wants it to come back on refresh.
 */
export default function PlanBanner({ used, onUpgrade }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const atLimit = used >= FREE_PLAN_LIMIT;
  return (
    <div
      className={`tc-plan-banner ${atLimit ? 'tc-plan-banner--at-limit' : ''}`}
      role="status"
      data-testid="plan-banner"
      data-at-limit={atLimit ? 'true' : 'false'}
    >
      <div className="tc-plan-banner-body">
        <span className="tc-plan-banner-label">Free Plan</span>
        <span className="tc-plan-banner-dot" aria-hidden="true">·</span>
        <span className="tc-plan-banner-text" data-testid="plan-banner-usage">
          You've used <strong>{used} of {FREE_PLAN_LIMIT}</strong> rooms this month.
        </span>
        <button
          type="button"
          className="tc-plan-banner-cta"
          onClick={onUpgrade}
          data-testid="plan-banner-upgrade"
        >
          <Sparkles className="w-3.5 h-3.5" />
          <span>Upgrade to Business</span>
          <span aria-hidden="true">→</span>
        </button>
      </div>
      <button
        type="button"
        className="tc-plan-banner-close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        data-testid="plan-banner-close"
      >
        <X className="w-3.5 h-3.5" />
      </button>
      <span className="tc-plan-banner-mock-note">
        (Mocked plan — Stripe integration pending)
      </span>
    </div>
  );
}
